module.exports = __webpack_public_path__ + "assets/img/Trade-Glass-Depot-Website-w720.8fbaac92.webp";